export const SEO_DEFAULT_BASE_URL = "https://reviewed.co.kr"

export const getPublicBaseUrl = () => {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || SEO_DEFAULT_BASE_URL
  return baseUrl.replace(/\/$/, "")
}

export const getServerApiBaseUrl = () => {
  const baseUrl = process.env.API_URL ?? process.env.NEXT_PUBLIC_API_URL ?? ""
  return baseUrl.replace(/\/$/, "")
}

export const getClientApiBaseUrl = () => process.env.NEXT_PUBLIC_API_URL ?? ""

export const getNaverSiteVerification = () => process.env.NEXT_PUBLIC_NAVER_SITE_VERIFICATION ?? ""

export const getGoogleSiteVerification = () => process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION ?? ""

export const getGtmId = () => process.env.NEXT_PUBLIC_GTM_ID ?? ""

export const SEO_ENV_IMPACT = {
  publicBaseUrl: [
    "robots.txt",
    "sitemap",
    "JSON-LD",
    "llms.txt",
    "Open Graph",
    "canonical",
    "hreflang",
  ],
  locale: ["SUPPORTED_LOCALES", "middleware", "messages", "hreflang", "sitemap alternates"],
  serverApiBaseUrl: ["sitemap route", "serverApi", "hospital sitemap API"],
  clientApiBaseUrl: ["api proxy", "auth refresh", "client API"],
} as const

export const SEO_PHASE_RUNTIME_PACKAGES = [] as const
